<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<mask id="mask0_3972_1264" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="20">
<rect width="20" height="20" fill="#D9D9D9"/>
</mask>
<g mask="url(#mask0_3972_1264)">
<path d="M2.9165 14.6955V13.4457H17.0832V14.6955H2.9165ZM2.9165 10.6251V9.3751H17.0832V10.6251H2.9165ZM2.9165 6.55448V5.30469H17.0832V6.55448H2.9165Z" fill="currentColor"/>
</g>
</svg>
